import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Address, FileDictionary } from "../common";

@CwtModel({ name: 'client' })
@CwtCrudContract({  path: 'client', searchMapper: (s) => ({ name: { regexp: s } }), })
export class Client extends CwtApiEntity {
    @CwtProp() name: string;
    @CwtProp({ ref: Address }) address: Address;
    @CwtProp() email: string;
    @CwtProp() phone: string;
    @CwtProp() usesThermalCure: boolean;
    @CwtProp() usesCompanyQuestions: boolean;
    @CwtProp() usesNamedEvaluations: boolean;
    @CwtProp() usesNamedRegistration: boolean;
    @CwtProp() allowOptionalCompanyQuestions: boolean;
    @CwtProp({ ref: FileDictionary }) privacyPolicy: FileDictionary;
    @CwtProp({ ref: FileDictionary }) termsOfUse: FileDictionary;

    public get features() {
        return {
            usesThermalCure: this.usesThermalCure ?? false,
            usesCompanyQuestions: this.usesCompanyQuestions ?? false,
            usesNamedEvaluations: this.usesNamedEvaluations ?? false,
            usesNamedRegistration: this.usesNamedRegistration ?? false,
            allowOptionalCompanyQuestions: this.allowOptionalCompanyQuestions ?? false,
        }
    }
}